import script from "./Progress_bar.vue?vue&type=script&setup=true&lang=js"
export * from "./Progress_bar.vue?vue&type=script&setup=true&lang=js"

import "./Progress_bar.vue?vue&type=style&index=0&id=55671988&lang=css"

const __exports__ = script;

export default __exports__